import * as d3 from "d3";

export type TickVisibility = {
  showXTicks: boolean;
  showYTicks: boolean;
};

export const applyTickVisibility = (
  plotClassName: string,
  { showXTicks, showYTicks }: TickVisibility,
) => {
  const svg = d3.select(`svg.${plotClassName}`);
  svg.selectAll(".x-axis .tick").style("opacity", showXTicks ? 1 : 0);
  svg.selectAll(".y-axis .tick").style("opacity", showYTicks ? 1 : 0);
};

export const resolveTickVisibility = (config: {
  showXTicks?: boolean;
  showYTicks?: boolean;
}): TickVisibility => ({
  showXTicks: config.showXTicks ?? true,
  showYTicks: config.showYTicks ?? true,
});
